import { useContext } from 'react'
import { GlobalContext } from '../context/global'
import theme from '../theme'

export default function useTheme() {
  const [state, dispatch] = useContext(GlobalContext);
  const currentTheme = theme[state.theme]
  return currentTheme;
}